// Brand asset URLs and shared constants.
// Text branding (BRAND) is a hard default. All CONTACT info now lives in
// admin Settings (`useSettings()`) and Header/Footer read from there.
export const BRAND = {
  name: "Queensway Studio",
  phone: "+221 78 113 05 16",
  phoneE164: "+221781130516",
  email: "queenswaysn@gmail.com",
  instagram: "https://www.instagram.com/queensway_studio/",
  threads: "https://www.threads.com/@queensway_studio",
  locationDakar: "Dakar, Sénégal",
  locationLondon: "London, United Kingdom",
  domain: "queenswaystudio.com",
};

// Fallback images bundled with the site. Any admin-uploaded image will take
// precedence via useSiteImage() below.
export const IMG = {
  logo: "/logo.jpg",
  hero: "/hero.jpg",
  studio: "/studio.jpg",
  lashes: "/lashes.jpg",
  botox: "/botox.jpg",
  iv: "/iv-generated.jpg",
  brows: "/brows.jpg",
  fillers: "/fillers.jpg",
};

export const CATEGORY_ORDER = ["botox", "fillers", "iv", "lashes", "brows"];
export const CATEGORY_IMG = {
  botox: IMG.botox,
  fillers: IMG.fillers,
  iv: IMG.iv,
  lashes: IMG.lashes,
  brows: IMG.brows,
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve an image URL from the settings object. If the admin has uploaded a
 * custom image (`img_<key>`), use it. Otherwise fall back to the bundled asset.
 *
 * @param {object} settings - the object from useSettings().settings
 * @param {"logo"|"hero"|"studio"|"botox"|"fillers"|"iv"|"lashes"|"brows"} key
 */
// Category display label — admin override via cat_<cat>_label_<lang>, else i18n fallback.
export function catLabel(settings, lang, cat, fallback) {
  const v = settings?.[`cat_${cat}_label_${lang === "fr" ? "fr" : "en"}`];
  return (typeof v === "string" && v.trim()) || fallback;
}

export function resolveSiteImage(settings, key) {
  const override = settings?.[`img_${key}`];
  if (override) {
    // Backend paths like /api/uploads/xxx need the backend origin prepended.
    return override.startsWith("http") ? override : `${BACKEND_URL}${override}`;
  }
  return IMG[key];
}
